import $ from "jquery";
import deferAction from "scripts/utils/deferAction";
import FacebookPixel from "./FacebookPixel/FBQ";

// TODO: remove this function
// const loadImages = (index, element) => {
//   const src = $(element).attr("data-src");
//   $(element).attr("src", src);
// };

const loadImagesBackground = (_, element) => {
  const src = $(element).attr("data-src");
  $(element).attr("style", `background-image: url(${ src })`);
};

const header = () => {
  let windowWidth = window.innerWidth;

  const mobileAppend = deferAction.bind(null, (isDesktop) => {
    const headerAppedsHolder = $(".header-category__mobile");

    if (
      !isDesktop &&
      windowWidth < 1250 &&
      headerAppedsHolder.find(".header-nav-menu").length === 0
    ) {
      const controlsMenu = $(".header-controls__menu");
      $(".header-category .wrapper").prepend(controlsMenu);

      const elements = [
        $(".header .header-info .stores-link"),
        $(".header .header-nav-menu"),
        $(".footer .nav-item.js-mobile-clone").clone(),
        $(".footer .mobile-app__store").clone(),
        $(".footer .footer-contacts").clone(),
      ];

      elements.forEach((item) => {
        headerAppedsHolder.append(item);
      });
    } else if (
      // isDesktop &&
      windowWidth >= 1250 &&
      headerAppedsHolder.find(".header-nav-menu").length !== 0
    ) {
      const headerInfo = $(".header-category__mobile .stores-link");
      const headerNavMenu = $(".header-category__mobile .header-nav-menu");
      const controlsMenu = $(".header-category .header-controls__menu");

      $(".header-info").append(headerInfo);
      $(".header__nav .wrapper").append(headerNavMenu);
      $(".header-controls").append(controlsMenu);
      $(".header-category__mobile").html("");
    }
  });

  $(window).on("resize", () => {
    windowWidth = window.innerWidth;
    mobileAppend();
  });

  const toggleHamburgerMenu = deferAction.bind(null, () => {
    const headerEl = document.querySelector(".header");
    const htmlEl = document.documentElement
    const isOpenMenu = headerEl.classList.contains("active");

    headerEl.classList.toggle("active", !isOpenMenu);
    htmlEl.classList.toggle("overflow", !isOpenMenu);
  });

  const openHamburgerMenu = () => {
    const element = $(".hamburger");

    element.on("click", () => {
      toggleHamburgerMenu();
      mobileAppend(false);

      const menuImages = $(".js_menu_img");
      const firstImgHolder = $(menuImages[0]);
      const style = firstImgHolder.attr("style");

      if (firstImgHolder.attr("data-src") && (!style || !style.includes(firstImgHolder.attr("data-src")))) {
        menuImages.each(loadImagesBackground);
      }
    });

    element.one("click", () => {
      const certificatesImages = $(".js_certificate_img");
      certificatesImages.each(loadImagesBackground);
    })
  };

  const closeHamburgerMenu = () => {
    const element = $(".header-category");

    element.on("click", (e) => {
      if ($(window).width() < 1251 && !$(e.target).closest(".wrapper").length) {
        toggleHamburgerMenu();
      }
    });
  };

  const langMenu = () => {
    const lang = $(".lang");

    const close = () => {
      lang.removeClass("active");
    };

    const documentHandler = (event) => {
      if (!event.target.closest(".lang")) {
        close();
        document.removeEventListener("click", documentHandler, false);
      }
    };

    const open = () => {
      lang.addClass("active");
      document.addEventListener("click", documentHandler, false);
    };

    lang.on("click", ".lang__current", () => {
      const $this = $(this);
      if (!lang.hasClass("active")) {
        open($this);
      } else {
        close($this);
      }
    });
  };

  const subcategoryOpener = () => {
    const opener = $(".subcategory__item ");

    const grid = (element) => {
      const { top } = element.position();
      const scrollHeight = element.find(".item-dropdown").prop("scrollHeight");
      const index = element.index() + 1;
      const nextAll = element.nextAll(".subcategory__item").map((key, item) => {
        if ($(item).position().top > top) {
          return item;
        }

        return false;
      });

      nextAll.not(`:nth-child(4n+${index})`).css({
        "margin-top": `-${scrollHeight}px`,
      });
    };

    opener.on("click", function openSubItem(e) {
      const { target } = e;
      const $this = $(this);
      if ($(target).hasClass("opener")) {
        e.preventDefault();
        deferAction(() => {
          opener.not(this).removeClass("active");
          if (windowWidth >= 1250) {
            $(".subcategory__item").css({
              "margin-top": `0`,
            });

            if (!$this.hasClass("active")) {
              $this.addClass("active");
              grid($this);
            } else {
              $this.removeClass("active");
            }
          } else {
            $this.toggleClass("active");
          }
        });
      }
    });

    if (windowWidth > 1250) {
      opener.one("click", function setMaxHeight(e) {
        const $this = $(this)
        const backgroundImage = $this.closest(".content__top").find(".subcategory-bg")
        const currentHeight = backgroundImage.height()
        backgroundImage.height(currentHeight)
      })
    }
  };

  const mobileCategoryOpen = () => {
    const opener = $(".header-category__list > li > a");

    opener.on("click", function openSubCategory(e) {
      if (windowWidth < 1250) {
        const $this = $(this);
        const { left } = $this.position();
        const count = left + ($this.width() - 50);
        const { clientX } = e;
        const parent = $this.parent("li");
        if (parent.find(".category-dropdown").length && clientX > count) {
          e.preventDefault();
          parent.addClass("active");
          const subMenuImages = parent.find(".js_submenu_img");
          const firstImgHolder = $(subMenuImages[0]);
          const style = firstImgHolder.attr("style");
          if (firstImgHolder.attr("data-src") && (!style || !style.includes(firstImgHolder.attr("data-src")))) {
            parent.find(".js_submenu_img").each(loadImagesBackground);
          }
        }
      }
    });
  };

  const mobileCategoryClose = () => {
    const closer = $(".category-dropdown__head .back");

    closer.on("click", function closeCategory() {
      deferAction(() => {
        $(this).parents("li").removeClass("active");
      });
    });
  };

  const clickPhone = () => {
    $(document).on("click", ".footer-contacts .tel, .header-info .tel", () => {
      FacebookPixel.contact();
    });
  };

  const loadMenuImages = () => {
    if (windowWidth > 1250) {
      $(".js_submenu_img").each(loadImagesBackground);
    }
  };

  const loadCertificateImages = () => {
    if (windowWidth > 1250) {
      $(".js_certificate_img").each(loadImagesBackground);
    }
  }

  clickPhone();
  subcategoryOpener();
  langMenu();
  mobileCategoryOpen();
  mobileCategoryClose();
  mobileAppend(true);
  closeHamburgerMenu();
  openHamburgerMenu();
  loadMenuImages();
  loadCertificateImages();
};

export default header;
